<div class="recent_orders">

    <sm-title-bar pageTitle="Coupons" [backWithParams]="true" [headerCustomTemplate]="addButton">
      <ng-template #addButton>
        <!-- <button mat-flat-button color="accent" >
          <mat-icon class="material-icons-round" [inline]="true">add_circle</mat-icon>
          Create
        </button> -->
        <!-- *ngIf="couponData.length > 0 && !isLoading" -->
        <div class="create_btnyh" >
          <button mat-flat-button color="primary" (click)="AddCoupon()">
              <mat-icon>add</mat-icon> 
              Create coupons
          </button>
       </div>

      </ng-template>
    </sm-title-bar>
    <div *ngIf="isLoading" class="loader">
    </div>
    <div class="row" *ngIf="couponData.length > 0 && !isLoading">
      <div class="col-sm-3"  *ngFor="let item of couponData;let i=index;">
        <mat-card class="httt_secr">
          <div class="fl_orders">
            <div class="dd_tgter">
            <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
              <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu2="matMenu">
            <button mat-menu-item (click)="copymessage(item)">
              <mat-icon class="material-icons-outlined">content_copy</mat-icon>
              <span>Copy promo message</span>
          </button>
          <!-- <button mat-menu-item (click)="shareFacebook(item)">
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span>Share in Facebook</span>
        </button> -->
        <!-- <button mat-menu-item (click)="shareTwitter(item)">
          <mat-icon class="material-icons-outlined">share</mat-icon>
          <span>Share in Twittter</span>
      </button> -->
   
              <button mat-menu-item *ngIf="item.status == 3" (click)="changeStatus(item,1)">
                  <mat-icon class="material-icons-outlined">do_not_disturb_on</mat-icon>
                  <span>Enable coupon</span>
              </button>
              <button mat-menu-item *ngIf="item.status == 1 || item.status == 0" (click)="changeStatus(item,3)">
                  <mat-icon class="material-icons-outlined">do_not_disturb_off</mat-icon>
                  <span>Disable coupon</span>
              </button>
              <button mat-menu-item (click)="deleteCoupon(item,2)">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span>Delete coupon</span>
            </button>
          </mat-menu>
        </div>
           <!-- <div class="dropdown icn_plm">
                  <button type="button" class="btn btn-primary dropdown-toggle hvbr" data-toggle="dropdown">
                        <mat-icon>more_horiz</mat-icon>
                          </button>
                      <div class="dropdown-menu mlq">
                          <a class="dropdown-item" href="javascript:void(0)" *ngIf="item.status == 3" (click)="changeStatus(item,1)">Enable</a>
                          <a class="dropdown-item" href="javascript:void(0)" *ngIf="item.status == 1 || item.status == 0" (click)="changeStatus(item,3)">Disable</a>
                          <a class="dropdown-item" href="javascript:void(0)" (click)="deleteCoupon(item,2)">Delete</a>
                      </div>
                  </div> -->
             
             <div class="top_section_order">
                  <div class="dis_un" *ngIf="item.status == 1 || item.status == 0">
                    <!-- <mat-icon aria-hidden="true" style="color:#34bc27; position: relative; right: -8px;">check</mat-icon> -->
                    <span class="check_tt"></span>
                  </div>
                  <div class="dis_un" *ngIf="item.status == 3">
                    <!-- <mat-icon aria-hidden="true" style="color:#f39a24;position: relative; right: -8px;  ">error</mat-icon> -->
                    <span class="error_tt"></span>
                  </div>
                  <div class="ee">
                      <div class="ss">
                          <div class="ads_sec">
                              <div class="hm_icon_ogr">
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 475.293 475.293" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M430.734 415.882H44.559C19.988 415.882 0 395.894 0 371.323v-74.265c0-8.21 6.643-14.853 14.853-14.853 24.571 0 44.559-19.988 44.559-44.559s-19.988-44.559-44.559-44.559C6.643 193.088 0 186.445 0 178.235V103.97c0-24.571 19.988-44.559 44.559-44.559h386.176c24.571 0 44.559 19.988 44.559 44.559v74.265c0 8.21-6.643 14.853-14.853 14.853-24.571 0-44.559 19.988-44.559 44.559s19.988 44.559 44.559 44.559c8.21 0 14.853 6.643 14.853 14.853v74.265c-.001 24.57-19.988 44.558-44.56 44.558zM29.706 310.417v60.906c0 8.195 6.658 14.853 14.853 14.853h386.176c8.195 0 14.853-6.658 14.853-14.853v-60.906c-33.854-6.904-59.412-36.9-59.412-72.771s25.557-65.866 59.412-72.771V103.97c0-8.195-6.658-14.853-14.853-14.853H44.559c-8.195 0-14.853 6.658-14.853 14.853v60.906c33.854 6.904 59.412 36.9 59.412 72.771s-25.558 65.866-59.412 72.77z" fill="#ffc107" opacity="1" data-original="#000000" class=""></path><path d="m179.19 351.051 89.085-237.562 27.814 10.43-89.085 237.562zM167.382 242.647c-24.571 0-44.559-19.988-44.559-44.559s19.988-44.559 44.559-44.559 44.559 19.988 44.559 44.559-19.988 44.559-44.559 44.559zm0-59.412c-8.195 0-14.853 6.658-14.853 14.853s6.658 14.853 14.853 14.853 14.853-6.658 14.853-14.853-6.658-14.853-14.853-14.853zM320.911 334.764c-24.571 0-44.559-19.988-44.559-44.559s19.988-44.559 44.559-44.559 44.559 19.988 44.559 44.559-19.988 44.559-44.559 44.559zm0-59.412c-8.195 0-14.853 6.658-14.853 14.853s6.658 14.853 14.853 14.853 14.853-6.658 14.853-14.853-6.658-14.853-14.853-14.853z" fill="#ffc107" opacity="1" data-original="#000000" class=""></path></g></svg>
                              </div>
                          </div>
                          <div class="order_dec">
                              <h3>{{item.coupon_code}}</h3>
                              <p>{{item.service_type}}</p>
                              <p>{{item.start_date.slice(0,10) | date}} - {{item.end_date.slice(0,10) | date}}</p>
                              <p *ngIf="!item.businessHashId || item.businessHashId === 'null'"><span class="cum_text">Coupon Type :</span> For All Merchant</p>
                          </div>
                          <div class="coupons_ttht">
                            <!-- <p><span class="cum_text">Minimum Cart Value :</span> ₹{{item.minimum_cart_value}}</p>
                            <p><span class="cum_text">Discount Type :</span> {{item.discount_type === 1 ? 'Percent' : 'Amount'}}</p>
                            <p><span class="cum_text">Discount Value :</span> {{item.discount_value}}</p> -->
                            <div class="rates">
                              <div class="rate-item">
                                  <span class="rate-label">Minimum Cart Value</span>
                                  <span class="rate-value">
                                      <span class="original-rate">{{item.currency_symbol}}{{item.minimum_cart_value.toFixed(2)}}</span>
                                  </span>
                              </div>
                              <div class="rate-item">
                                <span class="rate-label">Discount Type</span>
                                <span class="rate-value">
                                    <span class="original-rate">{{item.discount_type === 1 ? 'Percent' : 'Amount'}}</span>
                                </span>
                            </div>
                              </div>
                              <div class="rates">
                                <div class="rate-item">
                                    <span class="rate-label">Discount Value </span>
                                    <span class="rate-value">
                                        <span class="original-rate" *ngIf="item.discount_type === 1">{{item.discount_value}}%</span>
                                        <span class="original-rate" *ngIf="item.discount_type === 2">{{item.currency_symbol}}{{item.discount_value.toFixed(2)}}</span>
                                    </span>
                                </div>
                                <div class="rate-item" *ngIf="item.membership_use_limit != null && item.membership_use_limit != 'null'">
                                  <span class="rate-label">Apply limit </span>
                                  <span class="rate-value">
                                      <span class="original-rate" *ngIf="item.membership_use_limit == 0">For lifetime</span>
                                      <span class="original-rate" *ngIf="item.membership_use_limit != 0">{{item.membership_use_limit}} times</span>
                                  </span>
                              </div>
                              
                            </div>
                            <div class="rates">

                              <div class="rate-item" >
                                <span class="rate-label">Total count </span>
                                <span class="rate-value">
                                  <span class="original-rate">{{item.no_of_time_access}}</span>
                                  
                                </span>
                              </div>
                            </div>
                              <!-- <div class="rates" *ngIf="item.membership_use_limit && item.membership_use_limit != 'null'">
                                <div class="rate-item">
                                    <span class="rate-label">Coupon apply limit </span>
                                    <span class="rate-value">
                                        <span class="original-rate" *ngIf="item.discount_type == 0">For lifetime</span>
                                        <span class="original-rate" *ngIf="item.discount_type != 0">{{item.membership_use_limit}} times</span>
                                    </span>
                                </div>
                             
                                </div> -->
                          </div>
                          <div class="sub3_order">
                              <p style="-webkit-box-orient: vertical;
                              display: -webkit-box;
                              -webkit-line-clamp: 2;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: normal;">{{item.description}}</p>
                          </div>
                      </div>
                  </div>
                  <div>
                    <mat-chip-list aria-label="Fish selection" class="mb-3">
                      <mat-chip
                      *ngIf="item.coupon_type == 1"
                      class="Graceful-box-active"
                      >Booking 
                      </mat-chip>
                      <mat-chip
                      *ngIf="item.coupon_type == 2"
                      class="Graceful-box-active2"
                      >Membership 
                      </mat-chip>
                   </mat-chip-list>
                  </div>
              </div>
          </div>
        </mat-card>
      </div>
  
  </div>
  
  
    
    
  <!--   
    <mat-paginator class="mt-4" [length]="totalData" [pageSize]="8" (page)="onPageChange($event)">
    </mat-paginator> -->
  
    <!-- sm-coupons-card -->
  
  
  </div>
  
  <!-- <ng-container *ngIf="couponData.length == 0 && !isLoading">
    <div class="merchant_detail_sec"  >
      <div class="mrt_offer" style="padding: 150px;
      text-align: center;">
  <svg viewBox="0 0 32 32" enable-background="new 0 0 32 32" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Layer_1"></g> <g id="Layer_2"> <g> <path d=" M23,26h7v-4v0c-1.7,0-3-1.4-3-3s1.3-3,3-3v0v-4h-7" fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></path> <path d=" M20,12H2v4v0c1.7,0,3,1.4,3,3s-1.3,3-3,3v0v4h18" fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></path> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="23" x2="23" y1="12" y2="14"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="23" x2="23" y1="24" y2="26"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="8" x2="18" y1="16" y2="16"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="13" x2="18" y1="20" y2="20"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="22" x2="22" y1="6" y2="8"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="23" x2="23" y1="17" y2="21"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="26" x2="25" y1="8" y2="9"></line> <line fill="none" stroke="#b0b0b0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="18" x2="19" y1="8" y2="9"></line> </g> </g> </g></svg>
  <h3 style="margin-top: 16px;
  color: #7c7c7c;
  font-size: 20px;
  margin-bottom: 5px;">
          No coupons created yet
        </h3>
        <p style="color: #7c7c7c;">
          You can create a coupon by clicking on the 'Create' button above.
        </p>
      </div>
    </div>   
  </ng-container> -->


   <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="couponData.length == 0 && !isLoading">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/coupon-image-preview.png">
                 </div>
                 <mat-card-title>No coupon added yet
                </mat-card-title>
                 <mat-card-content>Give your customers loyalty benefit, let them feel valued and appreciated. Once you add, all your coupons will appear here.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="AddCoupon()">
                        <mat-icon>add</mat-icon> 
                        Create coupons 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/watchvideo.png">
                 </div>
                 <mat-card-title>How to create a inventory?</mat-card-title>
                 <mat-card-content>Check our help document on creating a new business or professional service. You can check this video as well. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a coupon or if there's any issue while using them by your customers, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->